import { render, staticRenderFns } from "./rmBtod.vue?vue&type=template&id=7d4a67b9"
import script from "./rmBtod.vue?vue&type=script&lang=js"
export * from "./rmBtod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports